module.exports = __webpack_public_path__ + "assets/94e6f6a24da1725772ba478a0acfbaec.png";